export default __webpack_public_path__ + "bb9d3136ccac5917b45899ee29c17ccd.jpg";